// components/AboutSection.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/AboutSection.css';

function AboutSection() {
  const [activeTab, setActiveTab] = useState('headquarters');

  const tabs = {
    headquarters: {
      icon: '/images/Asset5.png', // chemin vers ton logo
      title: 'في المجلس',
      description: 'ندوة وطنية حول "العنف الذي تيسره التكنولوجيا ضد النساء والفتيات - جائحة رقمية صامتة',
      link: '/conference'
    },
    conference: {
      icon: '/images/Asset5.png', // chemin vers ton logo
      title: 'ندوة',
      description: 'ندوة وطنية تحت شعار "العنف الذي تيسره التكنولوجيا ضد النساء والفتيات - جائحة رقمية صامتة"، بمشاركة مؤسسات وقطاعات وفاعلين وخبراء، مغاربة، أفارقة، دوليين وأمميين',
      link: '/conference'
    },
    show: {
      icon: '/images/Asset6.png', // chemin vers ton logo
      title: 'عرض ضوئي - Mapping',
      description: 'أرقام، رسائل، تعبيرات ولوحات : عروض ضوئية على الواجهة الرئيسة لبناية المجلس الوطني لحقوق الإنسان للتحسيس ومناهضة العنف الرقمي ضد النساء والفتيات',
      link: '/conference'
    },
    caravan: {
      icon: '/images/Asset4.png',
      title: 'قافلة وطنية',
      description: 'قافلة متنقلة تجوب 12 مدينة ب 12 جهة طيلة أيام الحملة للقاء والتفاعل والتحسيس حول العنف الذي تيسره التكنولوجيا ضد النساء والفتيات',
      link: '/caravan'
    },
    music: {
      icon: '/images/Asset8.png',
      title: 'عروض فنية حقوقية',
      description: 'تعابير الحقوق: عروض فنية يومية في فضاءات مفتوحة، بمعارض مناهضة العنف ضد النساء والفتيات. تعابير وإبداعات شبابية للتعبير عن الحقوق، يوميا من الساعة السادسة إلى السادسة والنصف مساء',
      link: '/music'
    },
    stands: {
      icon: '/images/Asset7.png',
      title: 'معارض',
      description: 'أروقة ومعارض بساحات عمومية كبرى بمدينة الرباط (3 معارض، 3 فضاأت مختلفة) للتفاعل مع سكان العاصمة والقادمين إليها ومغادريها حول مخاطر العنف الرقمي ضد النساء والفتيات وسبل الوقاية منه والتبليغ عنه',
      link: '/stands'
    },
    closingEvent: {
      icon: '/images/Asset10.png',
      title: 'تعابير الحق',
      description: 'حفل تعابير الحق: تعبيرات فنية، تختتم حملة وطنية لمناهضة العنف الرقمي ضد النساء والفتيات وتخلد اليوم العالمي لحقوق الإنسان 80',
      link: '/closing-event'
    }
  };

  return (
    <section className="about-section">
      <div className="container">
        <h2 className="about-title">عن الحملة</h2>

        <div className="about-content">
          <p className="about-intro">
          حملة وطنية لمناهضة العنف الرقمي ضد النساء والفتيات
          </p>

          <div className="about-details">

            <div className="detail-card">
              <div className="detail-label"><img src="/images/duration.png" className="tab-icon2-img" /></div>

              <div className="detail-value">16 يوم</div>
            </div>
            <div className="detail-card">
              <div className="detail-label"><img src="/images/calandarv.png" className="tab-icon2-img" /></div>

              <div className="detail-value">25 نونبر - 10 دجنبر</div>
            </div>
          </div>
        </div>

        <div className="tabs-container">
          <div className="tabs-header">
            <button
              className={`tab-button ${activeTab === 'headquarters' ? 'active' : ''}`}
              onClick={() => setActiveTab('headquarters')}
            >
            بالمجلس
            </button>
            <button
              className={`tab-button ${activeTab === 'caravan' ? 'active' : ''}`}
              onClick={() => setActiveTab('caravan')}
            >
              قافلة وطنية
            </button>
            <button
              className={`tab-button ${activeTab === 'stands' ? 'active' : ''}`}
              onClick={() => setActiveTab('stands')}
            >
              معارض
            </button>
            <button
              className={`tab-button ${activeTab === 'closingEvent' ? 'active' : ''}`}
              onClick={() => setActiveTab('closingEvent')}
            >
            تعابير الحق
            </button>
          </div>

          <div className="tab-content">
    {activeTab === 'headquarters' ? (
      <div className="tab-double">
        <div className="tab-card">
          <img src={tabs['conference'].icon} alt="Logo" className="tab-icon-img" />
          <h3 className="tab-title">{tabs['conference'].title}</h3>
          <p className="tab-description">{tabs['conference'].description}</p>
          <Link to={tabs['conference'].link}>
            <button className="cta-button">المزيد</button>
          </Link>
        </div>

        <div className="tab-card">
          <img src={tabs['show'].icon} alt="Logo" className="tab-icon-img" />
          <h3 className="tab-title">{tabs['show'].title}</h3>
          <p className="tab-description">{tabs['show'].description}</p>
          <Link to={tabs['show'].link}>
            <button className="cta-button">المزيد</button>
          </Link>
        </div>
      </div>
    ) : activeTab === 'stands' ? (
      <div className="tab-double">
        <div className="tab-card">
          <img src={tabs['stands'].icon} alt="Logo" className="tab-icon-img" />
          <h3 className="tab-title">{tabs['stands'].title}</h3>
          <p className="tab-description">{tabs['stands'].description}</p>
          <Link to={tabs['stands'].link}>
            <button className="cta-button">المزيد</button>
          </Link>
        </div>

        <div className="tab-card">
          <img src={tabs['music'].icon} alt="Logo" className="tab-icon-img" />
          <h3 className="tab-title">{tabs['music'].title}</h3>
          <p className="tab-description">{tabs['music'].description}</p>
          <Link to={tabs['music'].link}>
            <button className="cta-button">المزيد</button>
          </Link>
        </div>
      </div>
    ) : (
      <>
        <img src={tabs[activeTab].icon} alt="Logo" className="tab-icon-img" />
        <h3 className="tab-title">{tabs[activeTab].title}</h3>
        <p className="tab-description">{tabs[activeTab].description}</p>
        <Link to={tabs[activeTab].link}>
          <button className="cta-button">المزيد</button>
        </Link>
      </>
    )}
  </div>

        </div>
      </div>
    </section>
  );
}

export default AboutSection;
